import React, { Component } from 'react';
import { ReactComponent as FacebookFullLogo } from '../static/Facebook-full-btn.svg';
import { ReactComponent as TwitterFullLogo } from '../static/Twitter-full-btn.svg';
import { ReactComponent as LinkedInFullLogo } from '../static/Linkedin-full-btn.svg';
import { ReactComponent as YoutubeFullLogo } from '../static/Youtube-full-btn.svg';
import './shareonplateform.scss';

export class FullFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="social-media-platform social-media-full-platform">
          <h3>How can i thank you? Spread the word!</h3>
          <span>
            If <strong>converter linkedin to PDF</strong> has helped you. you
            can help us too
          </span>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/socialpilot.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                {' '}
                <FacebookFullLogo />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/socialpilot_co"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterFullLogo />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/socialpilot/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInFullLogo />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/SocialpilotCo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeFullLogo />
              </a>
            </li>
          </ul>
        </div>
        <div className="copy-right-footer">
          <p>© 2022 SocialPilot.co All Rights Reserved</p>
        </div>
      </>
    );
  }
}
